<template>
  <div class="product">
    <div class="title">
      <h3>产品中心</h3>
      <button @click="addproject">新增产品</button>
    </div>

    <p class="tishi">*默认排序为0，序号越大排序越前</p>

    <div class="box">
      <table>
        <thead>
          <tr>
            <th style="width: 50px">序号</th>
            <th>产品图片</th>
            <th style="width: 350px">产品名称</th>
            <th style="width: 350px">产品分类</th>
            <th>产品系列</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in tableData" :key="index">
            <td>{{ item.num }}</td>
            <td><img :src="item.imgUrl" alt="" /></td>
            <td>{{ item.name }}</td>
            <td>{{ item.type }}</td>
            <td>{{ item.series }}</td>
            <td>
              <div>
                <span @click="rowSave(item, index)"
                  ><i class="el-icon-view">预览</i></span
                >
                <span @click="rowEdit(item, index)"
                  ><i class="el-icon-edit-outline">编辑</i></span
                >

                <span @click="open()"><i class="el-icon-delete">删除</i></span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="item">
        <!--分页 -->
        <div class="pagination">
          <span>共68条</span>
          <el-pagination
            class="explore_right_pages"
            layout="prev, pager, next"
            :current-page="currentPage4"
            @current-change="handleCurrentChange"
            :page-size="5"
            :total="68"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [
        {
          num: 1,
          imgUrl: require("@/static/indexBanner.png"),
          name: "CMM5-30Y煤矿用液压锚杆钻车",
          type: "井下掘进",
          series: "系列化煤矿用液压锚杆钻车",
          falg: true,
        },
        {
          num: 2,
          imgUrl: require("@/static/indexBanner.png"),
          name: "CMM5-30Y煤矿用液压锚杆钻车",
          type: "井下掘进",
          series: "系列化煤矿用液压锚杆钻车",
          falg: true,
        },
      ],
      currentPage4: 1,
    };
  },

  components: {},

  computed: {},

  methods: {
    //编辑产品
    rowEdit(item, index) {
      this.$router.push('/backIndex/product')
    },
    rowSave(item, index) {
      item.falg = !item.falg;
    },
    rowDelete(item, index) {
      this.tableData.splice(index, 1);
    },
    addproject() {
      // this.$router.replace({name:'addproduct'})
      this.$router.push("/backIndex/addproduct");
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    //提示框
    open(index) {
      this.$confirm("确认要删除吗？", "!注意", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "myClass",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>
<style lang='scss' scoped>
.product {
  margin: 17px 26px 20px 26px;
  box-sizing: border-box;
  padding: 18px 26px 0 26px;
  background: white;
  .title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 34px;
    h3 {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }
    button {
      width: 77px;
      height: 28px;
      background: #006fb8;
      color: white;
      border-radius: 2px;
      border: none;
    }
  }

  .tishi {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ff190c;
    line-height: 18px;
  }
  table {
    margin: 15px 0px 0px 0px;
    border-collapse: collapse;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    border-radius: 3px 3px 0px 0px;
    overflow: hidden;
    thead {
      //width: 100%;
      background: #006fb8;
      border-radius: 4px 4px 0px 0px;
      tr {
        height: 36px;
        color: rgba(255, 255, 255, 0.85);
        width: 100%;
        th {
          box-sizing: border-box;
          height: 36px;
          width: 200px;
          color: white;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.85);
        }
      }
    }
    tbody {
      tr {
        height: 106px;
        border-bottom: 1px solid #e8e8e8;
        td {
          text-align: center;
          height: 106px;
          img {
            width: 104px;
            height: 78px;
            margin: 10px 0px;
          }
          span {
            color: #006fb8;
            margin: 0px 5px;
          }
        }
        &:nth-child(even) {
          background-color: #f6f6f7;
        }
      }
    }

    .leaseCount {
      width: 100px;
      div {
        margin: 0 auto;
        text-align: center;
        width: 92px;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.box {
  //   border: 1px solid rgb(92, 0, 221);
  height: 650px;
  position: relative;
  .item {
    // height: 40px;
    // background-color: skyblue;
    position: absolute;
    right: 0px;
    bottom: 0px;
  }
  .pagination {
    // border: 1px solid red;
    display: flex;
    justify-content: center;
    align-items: center;
    //   margin-top: 30px;
    span {
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      margin-top: 6px;
      color: #666666;
    }
  }
}
</style>
<style lang='scss' scoped >
::v-deep .explore_right_pages {
  display: flex;
  align-items: center;
  justify-content: center;

  .el-pagination button:hover {
    color: #978d8d;
  }
  .el-pagination button {
    color: #999999;
  }

  .el-pager li {
    background-color: unset;
  }
  .el-pager li:hover {
    color: #999999;
  }
  .btn-prev {
    width: 32px;
    height: 32px;
    background: #f6f6f7;
    border-radius: 4px;
    border: 1px solid #cccccc;
    padding-left: 0;
    padding-right: 0;
    margin-right: 5px;
    margin-left: 10px;
  }
  .btn-next {
    width: 32px;
    height: 32px;
    background: #f6f6f7;
    border-radius: 4px;
    border: 1px solid #cccccc;
    padding-left: 0;
    padding-right: 0;
    margin-right: 5px;
  }
  .el-pager .number {
    width: 32px;
    height: 32px;
    line-height: 32px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #cccccc;
    margin-right: 5px;
    margin-right: 5px;
    color: #999999;
  }
  .el-pager .number:hover {
    color: #006fb8;
  }
  .el-pager li.active {
    border: none;
    cursor: pointer;
    background: #006fb8;
    color: #fff;
  }
  .el-pager li.active:hover {
    color: #fff;
    background: #006fb8;
  }
  .el-pager li.btn-quicknext {
    line-height: 28px;
    color: #999;
  }
}
</style>
<style lang='scss'>
.myClass {
  border: none;
  .el-message-box__header {
    background: #006fb8;
    color: white !important;
  }
  .el-button--primary {
    background: #006fb8;
  }
}
.el-message-box__title {
  color: white !important;
}
</style>
